import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';
import { DataSourceResponse, DeactiveEmployee, Employee } from '../../models';

@Injectable({ providedIn: 'root' })
export class EmployeeService extends ApiService {


  endPoint = '/api/employees';

  create(model: Employee) {
    return this.http.post<string>(`${this.clinicsBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: Employee) {
    return this.http.put<string>(`${this.clinicsBaseURL}${this.endPoint}/${id}`, model);
  }
  deactive(model: DeactiveEmployee) {
    return this.http.put<any>(`${this.clinicsBaseURL}${this.endPoint}/deactive`, model);
  }
  addAccount(id: string, model: any) {
    return this.http.post<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}/add-account`, model);
  }
  bindAccount(id: string, model: any) {
    return this.http.post<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}/bind-doctor`, model);
  }
  updateImage(id: string, imagePath: string) {
    return this.http.post<any>(`${this.clinicsBaseURL}${this.endPoint}/changeimage/${id}`, { "base64String": imagePath });
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }

  get(id: string): Observable<Employee> {
    return this.http.get<Employee>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }


  getList(queryParams: any): Observable<DataSourceResponse<Employee>> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
  }

  getClinicPositionEmployees(): Observable<Employee[]> {
    return this.http.get<Employee[]>(`${this.clinicsBaseURL}${this.endPoint}/clinic-position/employees`);
  }

}
